import { pipe, toUpper, replace } from 'ramda';
import moment from 'moment';

type StringFormatter = (a: string) => string;

const mutateStringToMomentFormat: StringFormatter = pipe(toUpper, replace(/O/g, 'o'))

export const parseDate = (date: string | Date, dateFormat: string) => moment(date).format(mutateStringToMomentFormat(dateFormat));
